import { render, staticRenderFns } from "./StepTabContact.vue?vue&type=template&id=b3dcb078&scoped=true"
import script from "./StepTabContact.vue?vue&type=script&lang=js"
export * from "./StepTabContact.vue?vue&type=script&lang=js"
import style0 from "./StepTabContact.vue?vue&type=style&index=0&id=b3dcb078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dcb078",
  null
  
)

export default component.exports